module.exports = __webpack_public_path__ + "img/sercbdjkffjdbfskjfnsld.c59955a6.png";